import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";

export const WelcomeBroadcastCard = () => {
  const { user } = useAuth();
  const adminEmail = user?.email;
  const [run, setRun] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/admin/welcome-broadcast"); setRun(data.run); } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (run?.status !== "running") return;
    const t = setInterval(load, 3000);
    return () => clearInterval(t);
  }, [run?.status, load]);

  const start = async (test) => {
    if (!test && !window.confirm("Send the welcome email to ALL current signups now? People who already got it are skipped.")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/welcome-broadcast", test ? { test_email: adminEmail } : {});
      setRun(data);
      toast.success(test ? `Test sent to ${adminEmail}` : `Sending to ${data.total} signups`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Could not start"); }
    setBusy(false);
  };

  return (
    <div className="card-panel p-5" data-testid="admin-welcome-broadcast">
      <div className="eyebrow text-gray-400">WELCOME EMAIL BROADCAST</div>
      <p className="mt-2 text-sm text-gray-300">Subject: Welcome in, glad you're here. Sends from info@ihatemyjob.app.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button onClick={() => start(true)} disabled={busy || run?.status === "running"} className="border border-[#2A2E39] text-gray-200 px-3 py-1.5 rounded text-xs disabled:opacity-60" data-testid="welcome-broadcast-test-btn">Send test to me</button>
        <button onClick={() => start(false)} disabled={busy || run?.status === "running"} className="hero-accent text-white font-bold px-3 py-1.5 rounded text-xs disabled:opacity-60" data-testid="welcome-broadcast-send-all-btn">Send to all signups</button>
      </div>
      {run && (
        <div className="mt-3 text-sm text-gray-300 space-y-1" data-testid="welcome-broadcast-status">
          <div>{run.test ? "Test run" : "Full run"}: <span className="text-white font-bold">{run.status}</span>, from {run.sender}</div>
          <div>Total {run.total}, sent {run.sent}, failed {run.failed}, skipped {run.skipped}</div>
          {run.failed_emails?.map(f => <div key={f.email} className="text-xs text-[#FD0F10]">{f.email}: {f.error}</div>)}
        </div>
      )}
    </div>
  );
};
